module.exports = {"130821100":"下板城镇","130821102":"甲山镇","130821103":"六沟镇","130821104":"三沟镇","130821105":"头沟镇","130821106":"高寺台镇","130821107":"鞍匠镇","130821108":"三家镇","130821109":"磴上镇","130821110":"上谷镇","130821200":"东小白旗乡","130821202":"刘杖子乡","130821203":"新杖子乡","130821204":"孟家院乡","130821205":"大营子乡","130821206":"八家乡","130821208":"满杖子乡","130821209":"石灰窑乡","130821210":"五道河乡","130821211":"岔沟乡","130821212":"岗子满族乡","130821214":"两家满族乡","130821216":"仓子乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130821.json
// module id = 182
// module chunks = 0